<template>
  <Layout title="Executed Contract" class="bg-light">
    <div class="flex-grow-1 flex-column d-flex py-5 flex-shrink-0 container justify-content-center">
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center">
          <h3 class="mb-5">{{ asset.name }}</h3>
          <Icon icon="handshake" :width="140" colour="#e1e8fa" class="mb-5" />

          <h4>Congratulations!</h4>
          <p>Your document has been signed by both parties and hence is "executed"!</p>
          <p>You can access this document in <InertiaLink :href="route('counter-party.index')">Counterparties</InertiaLink> section of your account.</p>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import Icon from '@/Icons/Icon';

export default {
  components: {
    Layout,
    Icon,
  },

  props: {
    asset: {
      type: Object,
      required: true,
    },
    counterparty: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    // hide any models that are open from the signed contract screen
    $('#signContract').modal('hide');
  },

};
</script>
